module.exports = __webpack_public_path__ + "static/turtle-creek-house43-7843da6847dd221d283b6291deb4ef71.jpg";